import axios from "axios";
import { getConfig } from '../configService';

export class GeoLocationService {
    static async getGeoLocation() {
        try {
            const response = await axios.get(`${getConfig().apiBaseUrl}/geolocation/v1/geolocation`);
            return await response.data;
        }
        catch (error) {
            return { city: 'Boca Raton' };
        }
    }
}